import api from './axios';
import { isPrivateProviderContext, privateManagementList } from './private-provider-management';

const categoryRequests = {
    getAllCategories(){
        return api.get('/category', { orgContext: 'tenant' })
    },
    getAssignableCategories(){
        if (isPrivateProviderContext()) return privateManagementList('categories', { assignable: true });
        return api.get('/category/assignable', { orgContext: 'tenant' })
    },
    saveCategory(form){
        return api.post('/category',form, { orgContext: 'tenant' })
    },
    updateCategory(id,form){
        return api.patch(`/category/${id}`,form, { orgContext: 'tenant' })
    },
    deleteCategory(id){
        return api.delete(`/category/${id}`, { orgContext: 'tenant' })
    }
};

export default categoryRequests;
